<template>
	<div class="p-grid p-pb-6 recipe-overview">
		<div class="p-col-12 p-pt-1 p-pb-1">
      <div class="p-grid p-nogutter" style="min-height: 75px;">
        <div class="p-col">
          <h2 v-if="serialNumber == null">
            <a @click="$router.push({ name: 'library' })" style="cursor: pointer">{{$t('library.title_web')}}</a>
            <img class="p-pl-3 p-pr-2" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/>
            {{recipe ? recipe.name : "" }}
          </h2>
          <h2 v-else>
            <a @click="$router.push({ name: 'appliance-details', params: { serialNumber: serialNumber } })" style="cursor: pointer">{{appliance.name ?? $functions.fixModelName(appliance.modelNumber)}}</a>
            <img class="p-pl-3 p-pr-3" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/>
            <a @click="$router.push({ name: 'appliance-library', params: { serialNumber: serialNumber } })" style="cursor: pointer">{{$t('library.title_device')}}</a>
            <img class="p-pl-3 p-pr-2" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/>
            {{recipe ? recipe.name : "" }}
          </h2>
        </div>
        <div class="p-col-fixed p-pb-4" style="width: fit-content">
          <Button v-if="(appliance && appliance.online)" :disabled="(appliance.cycleRunning)" :label="$t('details.buttons.cycle_start_button')" @click="() => { dialog.start = true; }"  />
        </div>
      </div>

      <div class="p-mt-2 p-mb-2">
        <Carousel v-if="recipe && (!appliance || (appliance && appliance.gamma && appliance.gamma === 'MF Next'))" :recipe="recipe" />
      </div>

      <ButtonInfo class="p-m-2" :serialNumber="serialNumber" :recipe="recipe" :appliance="appliance"/>
      <ButtonEdit v-if="buttonVisible" class="p-m-2" :serialNumber="serialNumber" :recipe="recipe" :appliance="appliance"/>
      <ButtonDelete v-if="buttonVisible && recipe && recipe.type === 1" class="p-m-2" :serialNumber="serialNumber" :recipe="recipe" :appliance="appliance"/>
      <ButtonShare v-if="buttonVisible && recipe && recipe.type === 1" class="p-m-2" :serialNumber="serialNumber" :recipe="recipe" :appliance="appliance"/>

		</div>

    <!--                    -->
    <!-- ERRORS and SUCCESS -->
    <!--                    -->
    <IrinoxDialogDark :visible="dialog.error" 
      mode="error" 
      :message="$t('library.dialog_error')"
      :life="3000" 
      @update:visible="dialog.error = $event" />

    <IrinoxDialogDark :visible="dialog.start" mode="confirm" 
      :leftB="$t('library.cycle.start_dialog_cancel_button')" @click:left-button="() => {dialog.start = false;}" 
      :rightB="$t('library.cycle.start_dialog_ok_button')" @click:right-button="startCycle" 
      :message="$t('library.cycle.start_dialog')"
      icon="assets/irinox/icons/play_big.svg" />
    <IrinoxDialogDark :visible="dialog.startSuccess" 
      mode="success" 
      :message="$t('library.cycle.start_dialog_success')"
      :life="3000" 
      @update:visible="dialog.startSuccess = $event" />

	</div>
</template>

<script>
import RecipeService from '../../../service/RecipeService';
import EventHubListenerService from '../../../service/EventHubListenerService';
import Carousel from './mf/Carousel.vue';
import ButtonInfo from './ButtonInfo.vue';
import ButtonEdit from './ButtonEdit.vue';
import ButtonDelete from './ButtonDelete.vue';
import ButtonShare from './ButtonShare.vue';
import { mapGetters } from 'vuex';
import IrinoxDialogDark from '../../IrinoxDialogDark.vue';

export default {

  components: {
    Carousel,
      ButtonInfo,
      ButtonEdit,
      ButtonDelete,
      ButtonShare,
      IrinoxDialogDark,
    },
    data() {
        return {
          serialNumber: this.$route.params.serialNumber,
          recipeId: this.$route.params.recipeId,
          recipe: null,
          dialog: {
            error: false,
            start: false,
            startSuccess: false
          }
        };
    },
    computed: {
      ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          unit: 'userdata/unit',
          isCelsius: 'userdata/isCelsius',
          role: 'userdata/role',
        }),
        appliance: function() {
            return this.serialNumber ? this.$store.getters['appliances/appliance'](this.serialNumber) : null;
        },
        buttonVisible: function() {
          return this.role === "USER";
        }
    },
    created() {
      this.recipeService = new RecipeService();
      this.eventHubListenerService = new EventHubListenerService();
    },
    mounted() {
      this.recipeService.getRecipeDetails(this.personaltoken, this.recipeId, this.serialNumber)
        .then((data) => {
          if(data.code === '200') {
            this.recipe = data.body;
            if(this.serialNumber && this.role === "USER" && this.recipe.type === 1) { // Solo per USER su ricette CUSTOM
              this.recipeService.associateRecipe(this.personaltoken, this.recipeId)
                .then((data2) => {
                  if(data2.code!="200") {
                    console.error("ERROR "+JSON.stringify(data2));
                  }
                })
                .catch(error => {
                  console.error("ERROR "+error);
                });
            }
          } else {
            console.error("ERROR "+JSON.stringify(data));
            this.recipe = null;
            this.dialog.error = true;
            setTimeout(function () {
              this.$functions.historyBack();
            }.bind(this), 3000);
          }
        })
        .catch(error => {
          console.error("ERROR "+error);
          this.recipe = null;
          this.dialog.error = true;
          setTimeout(function () {
            this.$functions.historyBack();
          }.bind(this), 3000);
        });
    },
    methods: {
      startCycle() {
        let startCommand = {
          id: this.recipeId,
          operationSet: 1
        };
        this.dialog.start = false;
        this.eventHubListenerService.postStartStop(this.personaltoken, this.serialNumber, startCommand)
          .then((data) => {
            if(data.code=="200") {
              this.dialog.startSuccess = true;
              setTimeout(function() {
                this.$router.push({ name: 'appliance-details', params: { serialNumber: this.serialNumber } });
              }.bind(this),3000);
            } else {
              console.error("ERROR "+JSON.stringify(data));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("ERROR "+error);
            this.dialog.error = true;
          });
      }
    }

}
</script>

<style scoped>
</style>